// @vendors
const React = require("react");
const { formatText, FormattedText } = require("core/i18n").i18n;
const PropTypes = require("prop-types");

// @commons
const { InputSafe } = require("commonsComponents/inputSafe");
const { OKBoxTitle } = require("commonsComponents/OKBoxTitle");
const { OKButton } = require("commonsComponents/OKButton");

// @constants
const { nonNumericFilter } = require("utilities/stringHelper");

class ModifyEcommerceKeyStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            keyVisible: false,
            missedKeyTest: 0,
            newEcommerceKey: ""
        };
    }

    generateText = missedKeyTest => {
        const liClass = new Array(4)
            .fill(0)
            .map((x, y) =>
                y === missedKeyTest - 1
                    ? "ecommerce-key-modify-view__li-error"
                    : "ecommerce-key-modify-view__li-normal"
            );

        return (
            <div className="ecommerce-key-modify-view__requirements-list">
                <ul className="ecommerce-key-modify-view__requirements-list">
                    <li className={liClass[0]}>
                        <FormattedText value="eCommerceKeyModify-requirement1" />
                    </li>
                    <li className={liClass[1]}>
                        <FormattedText value="eCommerceKeyModify-requirement2" />
                    </li>
                    <li className={liClass[2]}>
                        <FormattedText value="eCommerceKeyModify-requirement3" />
                    </li>
                    <li className={liClass[3]}>
                        <FormattedText value="eCommerceKeyModify-requirement4" />
                    </li>
                </ul>
            </div>
        );
    };

    handleShowOrHide = () => {
        const { keyVisible } = this.state;
        this.setState({
            keyVisible: !keyVisible
        });
    };

    handleChange = evt => {
        const { value } = evt.target;
        const { immProfile, setEcommerceKey } = this.props;
        const birthDate = immProfile.get("fechaNacimiento");
        const newEcommerceKey = nonNumericFilter(value).trim();
        let missedKeyTest = this.validateKey(newEcommerceKey, birthDate);
        this.setState({
            newEcommerceKey,
            missedKeyTest
        });
        setEcommerceKey(newEcommerceKey);
    };

    validateKey = (newEcommerceKey, birthDate) => {
        const ASCENDING = "0123456789";
        const DESCENDING = "9876543210";
        const EQUAL = /\b([a-zA-Z0-9])\1+\b/;
        const birthYear = birthDate.substr(0, 4);

        if (newEcommerceKey.length === 0) {
            return 0;
        } else if (isNaN(newEcommerceKey) || !Number.isInteger(parseFloat(newEcommerceKey))) {
            return 1;
        } else if (newEcommerceKey.length >= 4 && (ASCENDING.includes(newEcommerceKey) || DESCENDING.includes(newEcommerceKey))) {
            return 2;
        } else if (
            newEcommerceKey.length >= 4 &&
            newEcommerceKey.match(EQUAL)
        ) {
            return 3;
        } else if (birthYear === newEcommerceKey) {
            return 4;
        } else {
            return 0;
        }
    };

    render() {
        const { keyVisible, newEcommerceKey, missedKeyTest } = this.state;
        const { showConfirmButton, isInputDisabled } = this.props;
        const requirementsBlock = this.generateText(missedKeyTest);
        const showText = formatText("eCommerceKeyModify-show");
        const hideText = formatText("eCommerceKeyModify-hide");
        const errorMessageText = formatText(
            "eCommerceKeyModify-errorRequirements"
        );
        const errorState = !!missedKeyTest && newEcommerceKey.length > 0;
        const totalDigits = 4;
        const canConfirm = !missedKeyTest && newEcommerceKey.length === totalDigits;

        const errorMessage = (
            <div className="ecommerce-key-modify-view__error-message">
                {errorMessageText}
            </div>
        );

        const confirmButton = (
            <div className="ecommerce-key-modify-view__content-block">
                <OKButton
                    disabled={!canConfirm}
                    onClick={this.props.handleConfirmButton(newEcommerceKey)}
                >
                    {formatText("eCommerceKeyModify-confirm")}
                </OKButton>
            </div>
        );

        return (
            <div className="ecommerce-key-modify-view__content-block">
                <OKBoxTitle
                    value={formatText("eCommerceKeyModify-secondTitle")}
                />
                <div className="ecommerce-key-modify-view__content-block">
                    <FormattedText
                        value={`eCommerceKeyModify-infoTextEcommerce`}
                    />
                </div>
                <div className="my-profile-ecommerce-key-info__section-container">
                    <div className="my-profile-ecommerce-key-info__section-container__title">
                        <FormattedText
                            value={`eCommerceKeyModify-titleSectionEcommerce`}
                        />
                    </div>
                </div>
                <form>
                    <div className="ecommerce-key-modify-view__content-block">
                        <div className="ecommerce-key-modify-view__input-container">
                            <InputSafe
                                disabled={isInputDisabled}
                                type={!!keyVisible ? "normal" : "password"}
                                id="newEcommerceKey"
                                label={formatText(
                                    "eCommerceKeyModify-inputLabel"
                                )}
                                maxLength={totalDigits}
                                name="newEcommerceKey"
                                onBlur={this.handleBlur}
                                onChange={this.handleChange}
                                value={newEcommerceKey}
                                errorState={errorState}
                                errorMessage=""
                            />
                        </div>
                        <div className="ecommerce-key-modify-view__input-container">
                            <div className="ecommerce-key-modify-view__button-container">
                                <OKButton
                                    modifier="ghost"
                                    leftIcon={
                                        keyVisible
                                            ? "icon-ocultar"
                                            : "icon-mostrar"
                                    }
                                    onClick={this.handleShowOrHide}
                                >
                                    {keyVisible ? hideText : showText}
                                </OKButton>
                            </div>
                        </div>
                    </div>
                    <div>{errorState && errorMessage}</div>
                </form>
                <div className="ecommerce-key-modify-view__content-block">
                    <div className="ecommerce-key-modify-view__requirements-block">
                        <FormattedText value="eCommerceKeyModify-requirements" />
                        {requirementsBlock}
                        {showConfirmButton && confirmButton}
                    </div>
                </div>
            </div>
        );
    }
}

ModifyEcommerceKeyStep1.propTypes = {
    validation: PropTypes.object,
    immProfile: PropTypes.object,
    isEditEnabled: PropTypes.bool,
    setField: PropTypes.func,
    immEcommerceKey: PropTypes.object,
    handleConfirmButton: PropTypes.func,
    showConfirmButton: PropTypes.bool,
    isInputDisabled: PropTypes.bool,
    setEcommerceKey: PropTypes.func
};

module.exports = ModifyEcommerceKeyStep1;
module.exports.constructor = ModifyEcommerceKeyStep1;
